import type { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { editorService } from '../../services';

export function useStaticData(): UseQueryResult<StaticData, AxiosError> {
    return useQuery('static-data', () => editorService.getStaticData());
}
